import React, { useState } from 'react';
import { auth } from '../data/auth';
import { LOGO_BASE64 } from '../data/logo';

export default function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [showPw, setShowPw]     = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) { setError('Enter username and password'); return; }
    setLoading(true);
    setError('');
    try {
      const result = await onLogin(username, password);
      if (result && result.error) { setError(result.error); }
    } catch(err) {
      setError('Login failed — make sure server is running');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight:'100vh', background:'linear-gradient(135deg,#1a2744 0%,#243054 60%,#1a3a5c 100%)',
      display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Inter,system-ui,sans-serif',
    }}>
      {/* Background pattern */}
      <div style={{position:'fixed',inset:0,opacity:0.03,backgroundImage:
        'repeating-linear-gradient(45deg,white 0,white 1px,transparent 0,transparent 50%)',
        backgroundSize:'20px 20px',pointerEvents:'none'}}/>

      <div style={{
        background:'white', borderRadius:12, padding:'40px 44px', width:400,
        boxShadow:'0 24px 64px rgba(0,0,0,0.4)', position:'relative',
      }}>
        {/* Logo */}
        <div style={{textAlign:'center', marginBottom:28}}>
          <img src={LOGO_BASE64} alt="Sterling Analytical"
            style={{height:70, width:'auto', marginBottom:12}}/>
          <div style={{fontSize:12, color:'#888', letterSpacing:'0.5px'}}>
            Laboratory Information Management System
          </div>
        </div>

        <div style={{fontSize:18, fontWeight:700, color:'#1e3060',
          marginBottom:20, textAlign:'center'}}>
          Sign In
        </div>

        {error && (
          <div style={{background:'#fff0f0', border:'1px solid #f0b8b8', borderRadius:6,
            padding:'9px 14px', fontSize:12, color:'#b83232', marginBottom:16,
            display:'flex', alignItems:'center', gap:8}}>
            ⚠️ {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:11, fontWeight:700, color:'#555',
              textTransform:'uppercase', letterSpacing:'0.4px', display:'block', marginBottom:5}}>
              Username
            </label>
            <input
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              placeholder="Enter username"
              style={{width:'100%', border:'1px solid #cdd3e4', borderRadius:6,
                padding:'10px 12px', fontSize:13, outline:'none', boxSizing:'border-box',
                transition:'border-color 0.15s'}}
              onFocus={e => e.target.style.borderColor='#1e3060'}
              onBlur={e => e.target.style.borderColor='#cdd3e4'}
            />
          </div>

          <div style={{marginBottom:22}}>
            <label style={{fontSize:11, fontWeight:700, color:'#555',
              textTransform:'uppercase', letterSpacing:'0.4px', display:'block', marginBottom:5}}>
              Password
            </label>
            <div style={{position:'relative'}}>
              <input
                type={showPw ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                style={{width:'100%', border:'1px solid #cdd3e4', borderRadius:6,
                  padding:'10px 40px 10px 12px', fontSize:13, outline:'none',
                  boxSizing:'border-box', transition:'border-color 0.15s'}}
                onFocus={e => e.target.style.borderColor='#1e3060'}
                onBlur={e => e.target.style.borderColor='#cdd3e4'}
              />
              <button type="button" onClick={() => setShowPw(v=>!v)}
                style={{position:'absolute', right:10, top:'50%', transform:'translateY(-50%)',
                  background:'none', border:'none', cursor:'pointer', fontSize:16, color:'#888'}}>
                {showPw ? '🙈' : '👁'}
              </button>
            </div>
          </div>

          <button type="submit" disabled={loading}
            style={{width:'100%', background: loading ? '#8899bb' : '#1e3060',
              color:'white', border:'none', borderRadius:6, padding:'12px',
              fontSize:14, fontWeight:700, cursor: loading ? 'not-allowed' : 'pointer',
              transition:'background 0.15s', letterSpacing:'0.3px'}}>
            {loading ? '⏳ Signing in...' : 'Sign In →'}
          </button>
        </form>

        <div style={{marginTop:20, padding:'10px 14px', background:'#f8f9ff',
          borderRadius:6, fontSize:11, color:'#888', textAlign:'center'}}>
          Default login: <strong style={{color:'#1e3060'}}>admin</strong> /
          <strong style={{color:'#1e3060'}}> admin123</strong>
          <br/>Change password in Admin Panel after first login
        </div>

        <div style={{marginTop:14, textAlign:'center', fontSize:11, color:'#aaa'}}>
          Sterling Analytical Laboratory · West Springfield, MA
        </div>
      </div>
    </div>
  );
}
